import { Operation } from "../operation.js";
import * as glMatrix from '../../../../node_modules/gl-matrix';
export class Tool extends Operation {
    position: glMatrix.vec2;

    constructor(gl: any, width: number, height: number, program: string, name: string) {
        super(gl, width, height, program, name);
        this._type = 'TOOL';
    }

}
